<template>
    <div>
        <button
            v-if="!disableButton"
            class="button is-outlined"
            :class="{ 'is-success ': appliedFilterCount > 0, 'is-cancel': appliedFilterCount == 0 }"
            @click="() => (isCollapsed ? onShow() : onHide())">
            <span class="icon">
                <Icon name="Filters" />
            </span>
            <span v-if="appliedFilterCount">
                {{ appliedFilterCount }}
            </span>
        </button>
        <Portal>
            <div
                :class="['asideMenu ' + classes, idMenu, { collapsed: isCollapsed }]"
                @mouseleave="onLeave"
                :ref="idMenu"
                :style="{ width: `${width}px` }">
                <div class="inner" style="overflow: hidden">
                    <template v-if="enableResize">
                        <div class="resizer" @mousedown="onResizerDown" :ref="`resizer.${idMenu}`"></div>
                    </template>

                    <div class="flex-1">
                        <div class="header v-center" v-if="showHeader">
                            <span
                                v-if="appliedFilterCount"
                                class="tag tag-filtercount mr5-xs"
                                :class="{ 'is-success': appliedFilterCount > 0 }"
                                >{{ appliedFilterCount }}</span
                            >
                            <slot name="header"> </slot>
                            <div class="ml-auto"></div>
                            <template v-if="enablePin">
                                <button class="button is-outlined is-small" @click="onHide">
                                    <span class="icon">
                                        <Icon name="UnPin" />
                                    </span>
                                </button>
                            </template>
                        </div>

                        <span class="on-collapsed">
                            <span class="tag" :class="{ 'is-success': appliedFilterCount > 0 }">
                                {{ appliedFilterCount }}
                            </span>
                        </span>
                        <slot></slot>
                    </div>
                </div>
            </div>
            <div class="asideMenu-Overlay" v-if="showOverlay" @click="collapseMenu"></div>
        </Portal>
    </div>
</template>

<script>
import { Portal } from '@linusborg/vue-simple-portal';
const SIDEMENU_WIDTH = 0;
const SIDEMENU_EXPANDED_WIDTH = 300;

/** This is a copy from sidemenu for usage in Hub-versions
 * idMenu is mandatory!
 * */
import Icon from './../public/Icon.vue';
export default {
    name: 'AsideMenu',
    components: {
        Icon,
        Portal,
    },
    props: {
        value: {
            type: Boolean,
        },
        idMenu: {
            type: String,
            required: true,
        },
        hasOverlay: {
            type: Boolean,
            default: false,
        },
        defaultClosed: {
            type: Boolean,
            default: false,
        },
        classes: {
            type: String,
            default: '',
        },
        enablePin: {
            type: Boolean,
            default: true,
        },
        disableButton: {
            type: Boolean,
            default: false,
        },
        disablePinHoverDelay: {
            type: Boolean,
            default: false,
        },
        saveState: {
            type: Boolean,
            default: true,
        },
        autoWidth: {
            type: Boolean,
            default: true,
        },
        enableResize: {
            type: Boolean,
            default: false,
        },
        asideMenuWidth: {
            type: Number,
            default: SIDEMENU_WIDTH,
        },
        asideMenuWidthExpanded: {
            type: Number,
            default: SIDEMENU_EXPANDED_WIDTH,
        },
        appliedFilterCount: {
            type: Number,
        },
        showHeader: {
            type: Boolean,
            default: true,
        },
    },
    data: function () {
        return {
            isCollapsed: false,
            isPinned: false,
            isOver: false,
            reactiveObject: 0,
        };
    },
    watch: {
        value(val) {
            if (val === true) {
                this.isCollapsed = false;
            }
        },
    },
    computed: {
        showOverlay() {
            return this.hasOverlay ? !this.isCollapsed : false;
        },
        savedWidth: {
            get: function () {
                this.reactiveObject;
                let stored = localStorage.getItem(`asideMenu.${this.idMenu}.width`);
                return stored ? JSON.parse(stored) : this.asideMenuWidthExpanded;
            },
            set: function (newValue) {
                localStorage.setItem(`asideMenu.${this.idMenu}.width`, JSON.stringify(newValue));
                this.reactiveObject++; //small hack to make reactive
            },
        },
        width() {
            if (this.isCollapsed) {
                return this.asideMenuWidth;
            } else {
                const maxSize = window.innerWidth - 150;
                return this.savedWidth > maxSize ? maxSize : this.savedWidth;
            }
        },
    },
    created() {
        document.addEventListener(`asideMenu_${this.idMenu}.show`, this.expandMenu);
        document.addEventListener(`asideMenu_${this.idMenu}.hide`, this.collapseMenu);
    },
    mounted() {
        if (this.defaultClosed) {
            this.collapseMenu();
        } else {
            this.handleSavedState();
        }
    },
    beforeDestroy() {
        var mainElement = document.getElementsByTagName('main').item(0);
        mainElement.style.paddingLeft = null;
        document.removeEventListener(`asideMenu_${this.idMenu}.show`, this.expandMenu);
        document.removeEventListener(`asideMenu_${this.idMenu}.hide`, this.collapseMenu);
    },
    methods: {
        handleSavedState() {
            this.isPinned = true;
            if (!this.disableButton) {
                //when no button to toggle is defined: set by state
                this.isPinned = localStorage.getItem(`asideMenu.${this.idMenu}.isPinned`) === 'true';
            }
            this.isCollapsed = this.isPinned ? false : true;
            if (this.enableResize && !this.isCollapsed) {
                this.handleSavedWidth();
            }
            this.handlePadding();
        },
        handleSavedWidth() {
            if (this.savedWidth) {
                this.setSize(this.savedWidth);
            }
        },
        handleAutoWidth() {
            /* not working atm: when reloading page with open sidebar content padding is not correct because sidebar hasn't reached it full width
      //auto width sidebar
      var sidebar = this.$refs[this.idMenu];
      if (this.autoWidth && !this.enableResize) {
        sidebar.classList.add("notransition");
        sidebar.style.width = this.isCollapsed ? null : "auto";
        let adjustedSidebar = sidebar.cloneNode(true);
        console.log(this.idMenu + ": width set", adjustedSidebar.style.width);
      }*/
        },
        handlePadding() {
            this.handleAutoWidth();

            //add spacing to body, only when no overlay is used
            if (!this.hasOverlay) {
                setTimeout(() => {
                    var sidebar = this.$refs[this.idMenu];
                    var mainElement = document.getElementsByTagName('main').item(0);
                    var newLeftPadding = this.isCollapsed ? this.asideMenuWidth : sidebar.clientWidth;
                    mainElement.style.paddingLeft = `${newLeftPadding}px`;
                }, 200); //wait for the sidebar animation to finish
            }
        },
        expandMenu() {
            this.isCollapsed = false;
            this.isPinned = true;
            if (this.enableResize) {
                this.handleSavedWidth();
            }
            this.$emit('input', false);
        },
        collapseMenu() {
            this.isCollapsed = true;
            this.isPinned = false;
            if (this.saveState) {
                localStorage.setItem(`asideMenu.${this.idMenu}.isPinned`, this.isPinned);
            }
            if (this.enableResize) {
                var sidebar = this.$refs[this.idMenu];
                if (sidebar) {
                    sidebar.style.width = null;
                }
            }
            this.handlePadding();
            this.$emit('input', false);
            document.removeEventListener('mouseUp', this.onResizerUp);
        },
        onOver() {
            //add small delay before showing
            this.isOver = true;
            const delay = this.disablePinHoverDelay ? 100 : 1500;
            setTimeout(() => {
                if (this.isOver) {
                    this.isCollapsed = false;
                    //this.handlePadding();
                    this.handleAutoWidth();
                }
            }, delay);
        },
        onLeave() {
            this.isOver = false;
            //ignore if sidebar has an overLay
            if (!this.hasOverlay) {
                this.isCollapsed = this.isPinned ? false : true;
                this.handlePadding();
            }
        },
        onShow() {
            this.isPinned = false;
            this.onPin();
        },
        onHide() {
            this.collapseMenu();
        },
        onPin() {
            if (this.isPinned) {
                this.collapseMenu();
            } else {
                this.isPinned = this.isPinned ? false : true;
                this.isCollapsed = this.isPinned ? false : true;

                if (this.enableResize) {
                    this.handleSavedWidth();
                }

                if (this.saveState) {
                    localStorage.setItem(`asideMenu.${this.idMenu}.isPinned`, this.isPinned);
                }

                this.handlePadding();
            }
        },
        setSize(size) {
            const maxSize = window.innerWidth - 150;
            const minSize = 150;

            //handle restrictions
            if (size > maxSize) {
                size = maxSize;
            }
            if (size < minSize) {
                size = minSize;
            }
            this.$refs[this.idMenu].style.width = `${size}px`;
        },
        resize(e) {
            e.preventDefault();
            const boundingClientRect = this.$refs[this.idMenu].getBoundingClientRect();
            const x = boundingClientRect.x;
            const change = x - e.x;
            const w = boundingClientRect.width;
            const size = w + change + 20; //15 width of resizer

            this.setSize(size);
        },
        onResizerDown(e) {
            e.preventDefault();
            if (this.idMenu && this.$refs[`resizer.${this.idMenu}`]) {
                this.$refs[`resizer.${this.idMenu}`].classList.add('onDrag');
                document.addEventListener('mousemove', this.resize);
                document.addEventListener('mouseup', this.onResizerUp);
            }
        },
        onResizerUp(e) {
            if (this.idMenu && this.$refs[`resizer.${this.idMenu}`]) {
                this.$refs[`resizer.${this.idMenu}`].classList.remove('onDrag');
            }
            //save the width
            this.savedWidth = this.$refs[this.idMenu].clientWidth;
            document.removeEventListener('mousemove', this.resize);
            document.removeEventListener('mouseup', this.onResizerUp);
        },
        onToggleSidebar() {
            document.dispatchEvent(new Event('toggleSidebar'));
        },
    },
};
</script>

<style lang="scss">
.notransition {
    -webkit-transition: none !important;
    -moz-transition: none !important;
    -o-transition: none !important;
    transition: none !important;
}

.flex-1 {
    flex: 1;
}

/* Optional Overlay
========================================================== */
.asideMenu-Overlay {
    background-color: var(--sidemenu-overlay-bg);
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 10000;
    cursor: pointer;
}

/* Default styling
========================================================== */
.asideMenu {
    position: fixed;
    top: 0;
    z-index: 8888;
    //margin-left: 15px;
    //height: calc(100vh - 60px);
    height: 100vh;
    padding: 0 15px 15px 15px;
    display: block;
    transition: width 200ms ease-out, left 200ms ease-out;

    background-color: transparent;
    padding: 15px 0;
    background-color: red;
    box-shadow: var(--default-box-shadow);

    padding-top: 0 !important;

    .btn-toggleSidebar {
        position: absolute;
        right: -50px;
        top: 0;
        width: 100%;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        margin: 15px 0;
        padding-left: 22px;
        padding-right: 22px;
        color: var(--color-txt);
        opacity: 0.5;
        z-index: 88;

        &:hover {
            opacity: 1;
        }
    }

    .inner {
        position: relative;

        display: flex;
        height: 100vh;
        width: 100%;
        padding: 0 15px 0 15px;

        //box-shadow: 5px 5px 10px #dddddd, -5px -5px 10px #ffffff;
        //border-radius: 15px;
        border-right: 2px solid #f2f3f3;
        border-left: 2px solid #f2f3f3;
        padding-top: 10px;
        background: var(--sidemenu-bg);
        background: #fff;
    }
    div.header {
        display: flex;
        height: 40px;
        align-items: center;
        margin: 0 -15px;
        padding: 5px 15px 5px;
        border: 0;

        h2 {
            margin: 0;
            font-size: 1.4rem;
            line-height: 40px;
            text-transform: none;
            letter-spacing: 0.02em;
            font-weight: 600;
            color: #888;
            text-transform: uppercase;
        }

        .dropdown .dropdown-menu .has-link a {
            overflow: hidden;
        }
    }

    &.has-back {
        .header {
            margin-top: -15px;
        }
        .scroll-sideMenu {
            height: calc(100vh - 210px); // 55 + 15 + 15
        }
    }
    .back {
        color: var(--color-txt);
        font-size: 1rem;
        margin: 15px 0;
        height: 55px;
        display: flex;
        align-items: center;
        border-bottom: 2px solid #eee;
        padding-bottom: 6px;
        margin-left: -30px; //full size line
        margin-right: -15px; //full size line
        padding-left: 30px;

        .text {
            margin-left: 10px;
        }
    }

    .dropdown {
        &.is-bottom-left .dropdown-menu {
            margin-right: 3px; //room for shadow
        }
        .dropdown-menu {
            margin-left: 3px; //room for shadow
        }
    }

    .scroll-asideMenu {
        height: calc(100vh - 200px); // 55 + 15 + 15
        overflow-x: hidden;
        overflow-y: auto;
        padding-right: 15px; //room for scrollbar
        margin-bottom: 15px;
    }

    .is-filter-pin {
        display: block;
        .icon {
            width: 18px;
            height: 18px;
            color: var(--color-txt);
            svg {
                height: inherit;
                width: inherit;
            }
        }
    }

    .button.is-sidebar {
        position: absolute;
        right: 0px;
        bottom: 15px;
        z-index: 890;
        width: 100%;
        border: none;
        background: none;
        display: flex;
        justify-content: flex-end;

        &:hover,
        &:focus,
        &:active {
            outline: none;
            box-shadow: none;
            span {
                color: #fff;
                background-color: var(--color-primary);
                border-color: var(--color-primary);
                box-shadow: none;
                outline: none;
                .icon svg {
                    color: #fff;
                }
            }
        }

        span {
            border-radius: 100%;
            background-color: #fff;
            border: 1px solid #e9e9e9;
            color: var(--color-txt);
            width: 28px;
            height: 28px;
            font-size: 1.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            .icon {
                width: 14px;
                height: 14px;
                color: var(--color-txt);
                svg {
                    height: inherit;
                    width: inherit;
                }
            }
        }
    }

    .button.is-toggler {
        position: absolute;
        top: 0;
        left: -15px;
        background-color: transparent;
        border-color: transparent;
        height: 100%;
        width: 100%;
        &:hover,
        &:focus {
            box-shadow: none;
            outline: none;
        }
    }

    &.collapsed {
        transition: width 200ms ease-out, left 200ms ease-out;
        box-shadow: none;
        overflow: hidden;
        .header {
            overflow: hidden;
            opacity: 0;
        }

        &.has-filters {
            button.is-sidebar {
                border-color: var(--success);
                background-color: var(--success);
                color: #fff;
            }
        }

        form {
            display: none;
        }

        .on-collapsed {
            display: inherit;
        }

        .resizer {
            display: none;
        }

        .hide-collapsed,
        .back {
            display: none;
        }

        ul.navbar-nav {
            overflow: hidden;
            li.header {
                position: relative;
                margin-right: 0;
                opacity: 1;
                span {
                    opacity: 0;
                    visibility: hidden;
                }
                &:before {
                    content: '';
                    position: absolute;
                    top: 8px;
                    left: 0;
                    border-top: 2px solid #ccc;
                    display: block;
                    width: 20px;
                }
                &.hideOnCollapse {
                    &:before {
                        opacity: 0;
                        visibility: hidden;
                    }
                }
            }

            li.nav-item {
                a {
                    span {
                        opacity: 0;
                        display: none;
                    }
                    span.icon {
                        display: inline-flex;
                        opacity: 1;
                    }
                }
                .dropdown {
                    .hideOnCollapse {
                        display: none;
                    }
                }
            }
        }
    }

    ul.navbar-nav {
        display: flex;
        flex-direction: column;
        padding-left: 7px;

        li.header {
            font-size: 1.2rem;
            font-weight: bold;
            text-transform: uppercase;
            color: #8b97a4;
            border-bottom: 0;
            height: auto;
            padding: 0;
            margin-top: 1em;
            margin-bottom: 0;
            &:first-child {
                padding-top: 0;
            }
        }
        li.nav-item {
            div.can > a,
            > a {
                padding: 12px 0;
                font-size: 1.6rem;
                color: #8b97a4;
                font-weight: 500;
                background-color: transparent;
                border-color: #eee;

                display: flex;
                align-items: center;
                white-space: nowrap;
                justify-content: flex-start;
                line-height: 18px;

                span.icon {
                    display: inline-flex;
                }

                .icon {
                    margin-right: 10px;
                    height: 18px;
                    width: 18px;
                    svg {
                        height: inherit;
                        width: inherit;
                    }
                }

                &:hover {
                    background-color: transparent;
                    border-color: transparent;
                    color: var(--color-txt);
                }
            }
            .dropdown {
                width: 100%;
                &.is-disabled {
                    opacity: 1;
                    cursor: default;
                }
                .dropdown-trigger .button {
                    color: #8b97a4;
                    text-decoration: none;
                    padding-left: 0;
                    padding-right: 0;
                    margin-left: 1px;
                    width: 100%;
                    &:focus {
                        box-shadow: none;
                        background-color: transparent;
                    }
                    &:hover {
                        color: var(--color-txt);
                        background-color: transparent;
                    }
                }
            }
            &.is-active a {
                color: var(--color-primary);
                background-color: transparent;
                border-color: #eee;
                .icon {
                    opacity: 1;
                }
            }
        }
    }

    .on-collapsed {
        display: none;
    }
    .action {
        margin: 20px 0;
    }

    .resizer {
        width: 5px;
        height: 100%;
        left: 5px;
        top: 0px;
        background-color: transparent;
        position: absolute;
        z-index: 2;
        cursor: col-resize;
        margin: 0;
        padding: 0;
        box-sizing: border-box;

        &:hover,
        &.onDrag {
            background-color: var(--color-primary);
        }

        &:before,
        &:after {
            content: '';
            position: absolute;
            top: 50%;
            left: 50%;
            background-color: #00000026;
            -webkit-transition: background-color 0.3s;
            transition: background-color 0.3s;

            transform: translateY(-50%);
            width: 1px;
            height: 30px;
        }
        &:before {
            margin-left: -2px;
        }
    }
}
</style>
